import React, { useContext } from 'react';
import { Typography, Box, Avatar, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import styles from './style';
import EditIcon from '@material-ui/icons/Edit';
import { I18nContext } from 'translations';

const DriverSelected = ({ classes, driver, setOpenModalServiceDriver }) => {
  const { translate } = useContext(I18nContext);
  return (
    <div>
      <Typography variant="subtitle2" color="primary" component="p" style={{ marginBottom: 12 }}>
        {translate('app.bookingReserved.driverReserved')}
      </Typography>
      <Box className={classes.driverInfoSection}>
        <Avatar
          className={classes.driverAvatar}
          src={driver?.driver?.photo_url ? driver?.driver?.photo_url : "/images/users/default-avatar.png"}
        />
        <Box className={classes.driverDetails}>
          <Typography className={classes.driverName}>
            {driver?.driver?.name}
          </Typography>
          <Typography className={classes.plateText}>
            <strong>{translate('app.bookingReserved.plate')}:</strong> {driver?.vehicle_plate ? driver?.vehicle_plate : '-'}
          </Typography>
          <Typography className={classes.phoneText}>
            {driver?.driver?.phone}
          </Typography>
          <Box className={classes.ratingContainer}>
            <StarIcon className={classes.starIcon} />
            <Typography className={classes.ratingText}>
              {driver?.driver?.rating_as_driver}
            </Typography>
          </Box>
        </Box>
        <IconButton
          color="primary"
          onClick={() => setOpenModalServiceDriver(true)}
        >
          <EditIcon />
        </IconButton>
      </Box>
    </div>
  );
};

export default withStyles(styles)(DriverSelected);